import { Flex, Heading } from "@instructure/ui";
import { t } from "i18next";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { ExternalService } from "../../../../../../services/ExternalService";
import { Selector } from "../../../../../Selectors/Selector";
import AssessmentChartData from "./AssessmentChartData";
import OverallChartData from "./OverallChartData";

const FlexibleAssessmentChart = ({
  measure,
  filters,
  prevFilters,
  triggerMap,
}) => {
  const [measureSubjects, setMeasureSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [fullOutcomes, setFullOutcomes] = useState(null);

  useEffect(() => {
    ExternalService.getExternalSubjectsByIds(measure.subjects).then((subs) => {
      subs.forEach((sub) => {
        sub.label = sub.name;
      });
      setMeasureSubjects(subs);
      setSelectedSubject(subs[0]);
      measure.subjects = subs;
    });
  }, [measure]);

  useEffect(() => {
    const loIds = measure.los.map((lo) => lo.id);
    ExternalService.getLearningOutcomesByIds(loIds).then((los) => {
      setFullOutcomes(los);
    });
  }, [measure]);

  const onSubjectSelect = (subject) => {
    const subObj = measureSubjects.find((sub) => sub.id === subject);
    setSelectedSubject(subObj);
  };

  return (
    <Flex wrap="wrap" gap="small">
      <Flex.Item size="100%">
        <Heading level="h3">{t("results.flexibleCanvasAssessment")}</Heading>
      </Flex.Item>
      <Flex.Item size="300px" padding="0 0 0 large">
        {measureSubjects.length > 0 ? (
          <Selector
            id={"subject-select-" + measure.id}
            label={t("subject.selector")}
            options={measureSubjects}
            selectHandler={onSubjectSelect}
            selectedItemId={selectedSubject?.id ?? null}
          />
        ) : (
          <Skeleton style={{ height: 64, borderRadius: 5 }} />
        )}
      </Flex.Item>
      <AssessmentChartData
        measure={measure}
        fullOutcomes={fullOutcomes}
        triggerMap={triggerMap}
        selectedSubject={selectedSubject}
        filters={filters}
      />
      <OverallChartData
        measure={measure}
        fullOutcomes={fullOutcomes}
        selectedSubject={selectedSubject}
        triggerMap={triggerMap}
        filters={filters}
        prevFilters={prevFilters}
      />
    </Flex>
  );
};

export default FlexibleAssessmentChart;
